import { Link } from "react-router-dom";

const hotTags = ["悬疑推理", "古装权谋", "硬核科幻", "家庭治愈", "刑侦追凶", "年代史诗"];

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 bg-primary-900 text-background-100">
      <div className="mx-auto grid w-full max-w-[1400px] gap-8 px-4 py-12 md:grid-cols-4 md:px-6 md:py-14">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-white">
              <i className="ri-movie-2-line text-xl" />
            </span>
            <span className="font-heading text-lg font-bold text-white">
              秋霞<span className="text-accent-400">影院</span>
            </span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-100">
            秋霞影院是一个面向广大影视爱好者的内容门户，汇聚丰富的电影与电视剧资源，提供清晰的分类筛选、
            详尽的影视资料以及及时的影视资讯，方便你在线浏览与了解影视相关内容。
          </p>
          <div className="mt-5 flex items-center gap-3">
            {["ri-wechat-line", "ri-weibo-line", "ri-mail-line"].map((icon) => (
              <span
                key={icon}
                className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-800 text-primary-100 transition-colors hover:bg-accent-500 hover:text-white"
              >
                <i className={icon} />
              </span>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-white">
            <Link to="/category/movie" className="transition-colors hover:text-accent-400">
              内容导航
            </Link>
          </h4>
          <ul className="mt-4 space-y-3 text-sm">
            <li>
              <Link to="/category/movie" className="text-primary-100 transition-colors hover:text-accent-400">
                电影专区
              </Link>
            </li>
            <li>
              <Link to="/category/tv" className="text-primary-100 transition-colors hover:text-accent-400">
                电视剧专区
              </Link>
            </li>
            <li>
              <Link to="/news" className="text-primary-100 transition-colors hover:text-accent-400">
                影视资讯
              </Link>
            </li>
            <li>
              <Link to="/search" className="text-primary-100 transition-colors hover:text-accent-400">
                全站搜索
              </Link>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-heading text-sm font-semibold text-white">热门标签</h4>
          <div className="mt-4 flex flex-wrap gap-2">
            {hotTags.map((tag) => (
              <Link
                key={tag}
                to={`/search?q=${encodeURIComponent(tag)}`}
                className="rounded-full bg-primary-800 px-3 py-1.5 text-xs text-primary-100 transition-colors hover:bg-accent-500 hover:text-white"
              >
                {tag}
              </Link>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full max-w-[1400px] flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-primary-200 md:flex-row md:px-6">
          <p>© {year} 秋霞影院. 本站内容为演示示例，仅用于展示影视信息浏览体验。</p>
          <p>声明：站内影视资料与资讯均为虚构演示数据，不提供任何影片下载与真实播放服务。</p>
        </div>
      </div>
    </footer>
  );
}